import { useFragment } from '@apollo/client';

import { Breadcrumbs } from '@components/Breadcrumbs';

import { ProductDetailsBreadcrumbsFragment, ProductDetailsBreadcrumbsFragmentDoc } from './gql/graphql.v3.generated';

type Catalog = {
  __typename?: 'RootCatalog',
  id: string,
}

interface Props {
  className?: string,
  catalog?: Catalog | null,
}

export const ProductDetailsBreadcrumbsContainer: React.FC<Props> = ({
  className,
  catalog,
}) => {
  const { data, complete } = useFragment<ProductDetailsBreadcrumbsFragment>({
    fragment: ProductDetailsBreadcrumbsFragmentDoc,
    from: catalog || null,
  });

  if (complete) {
    return (
      <Breadcrumbs
        className={className}
        breadcrumbs={data.breadcrumbs}
      />
    );
  }

  return null;
};
